import ReactDOM from 'react-dom'
import ApolloProvider from './ApolloProvider'
import './static/tailwind.css'

ReactDOM.render(ApolloProvider, document.getElementById('root'))